import { render, staticRenderFns } from "./ListarLicencias.vue?vue&type=template&id=631db946&"
import script from "./ListarLicencias.vue?vue&type=script&lang=js&"
export * from "./ListarLicencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports